import { CategoryData } from '../../../../types/types';

export const couleurs: CategoryData = {
  'Jɛman (Blanc)': {
    translation: 'Blanc',
    translationEn: 'White',
    illustration: '⚪',
    audio: 'Ba-jeman'
  },

  'Finman (Noir)': {
    translation: 'Noir',
    translationEn: 'Black',
    illustration: '⚫',
    audio: 'Ba-finman'
  },

  'Wulenman (Rouge)': {
    translation: 'Rouge',
    translationEn: 'Red',
    illustration: '🔴'
  },

  'Bulaman (Bleu)': {
    translation: 'Bleu',
    translationEn: 'Blue',
    illustration: '🔵'
  },

  'Nɛrɛman (Jaune)': {
    translation: 'Jaune',
    translationEn: 'Yellow',
    illustration: '🟡',
    audio: 'Ba-nereman'
  },





  'Ɲugujiman (Vert)': {
    translation: 'Vert',
    translationEn: 'Green',
    illustration: '🟢'
  },

  'Lankiriman (Violet)': {
    translation: 'Violet',
    translationEn: 'Purple',
    illustration: '🟣',
    audio: 'Ba-lankiriman'
  },

  'Worojima (Orange)': {
    translation: 'Orange',
    translationEn: 'Orange',
    illustration: '🟠',
    audio: 'Ba-worojima'
  },

  'Sikɔlɔman (Marron)': {
    translation: 'Marron',
    translationEn: 'Brown',
    illustration: '🟤'
  },

  'Malasa (Rose)': {
    translation: 'Rose',
    translationEn: 'Pink',
    illustration: '🌸'
  },

  'Jɛman-Finman (Gris)': {
    translation: 'Gris',
    translationEn: 'Gray',
    illustration: '⚪',
    audio: 'Ba-Jeman_finman'
  },

  'Sanin (Doré)': {
    translation: 'Doré',
    translationEn: 'Golden',
    illustration: '🥇',
    audio: 'Ba-sanin'
  },

  'Wari jɛ (Argenté)': {
    translation: 'Argenté',
    translationEn: 'Silver',
    illustration: '🥈'
  },

  'Yeelen (Clair)': {
    translation: 'Clair',
    translationEn: 'Light',
    illustration: '☀️',
    audio: 'Ba-yeelen'
  },

  'Dibi (Foncé)': {
    translation: 'Foncé',
    translationEn: 'Dark',
    illustration: '🌑',
    audio: 'Ba-dibi'
  },

  'Nɔgɔya caman (Multicolore)': {
    translation: 'Multicolore',
    translationEn: 'Multicolored',
    illustration: '🌈',
    audio: 'Ba-Nogoya_caman'
  },

  'Bugunbugun (Tacheté)': {
    translation: 'Tacheté',
    translationEn: 'Spotted',
    illustration: '🐆',
    audio: 'Ba-bugunbugun'
  }
};

export default couleurs;
export {};
